import { SignInDataPost, UserData } from "data/interfaces/signIn";
import { usePersistState } from "hooks/useSessionStorage";
import { createContext, ReactNode, useCallback, useMemo } from "react";
import { KEY_AUTH, KEY_USER } from "services/axios/api";
import { postSignIn } from "services/modules/signIn";

interface AuthProviderProps {
	children: ReactNode;
}

interface AuthContextData {
	onSignIn: (dataPost: SignInDataPost) => Promise<void>;
	onSignOut: () => void;
	token: string | null;
	user: UserData;
	getToken: () => Promise<string | null>;
}

export const AuthContext = createContext({} as AuthContextData);

export const AuthProvider = ({ children }: AuthProviderProps) => {
	const [user, setUser] = usePersistState<UserData>(KEY_USER, {} as UserData);
	const [token, setToken, getToken] = usePersistState<string | null>(
		KEY_AUTH,
		null,
	);

	const onSignIn = async (dataPost: SignInDataPost) => {
		const dataSignIn = await postSignIn(dataPost);

		if (dataSignIn) {
			setUser({
				email: dataSignIn.email,
				nome: dataSignIn.nome,
				idUsuario: dataSignIn.idUsuario,
			});
			setToken(dataSignIn.token);
		}
	};

	const onSignOut = useCallback(() => {
		sessionStorage.removeItem(KEY_USER);
		sessionStorage.removeItem(KEY_AUTH);
	}, []);

	const valuesContext = useMemo(() => {
		return {
			token,
			getToken,
			user,
			onSignIn,
			onSignOut,
		};
	}, [user, token]);

	return (
		<AuthContext.Provider value={valuesContext}>
			{children}
		</AuthContext.Provider>
	);
};
